import dayjs from "dayjs";
import utc from "dayjs-plugin-utc";
import timezone from "dayjs/plugin/timezone";
import "dayjs/locale/es"; // Importa el idioma español

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.locale("es");

export const dateLocal = (fecha = new Date()) => {
  return dayjs(fecha)
    .tz("America/Guayaquil")
    .format("YYYY-MM-DDTHH:mm:ss.SSS-05:00");
};

export const dateToText = (fecha = new Date()) => {
  return dayjs(fecha).tz("America/Guayaquil").format("DD [de] MMMM [del] YYYY");
};

const minuteCounters = new Map();

export const randInt = (min, max) =>
  Math.floor(Math.random() * (max - min + 1)) + min;

const timeToSeconds = (timeStr) => {
  const [h = 0, m = 0, s = 0] = String(timeStr || "00:00:00")
    .split(":")
    .map((n) => parseInt(n, 10) || 0);
  return h * 3600 + m * 60 + s;
};

export const buildRandomDateInMealHours = (date, minTime, maxTime) => {
  if (!minTime || !maxTime) {
    throw new Error("La comida no tiene horario definido");
  }

  const start = timeToSeconds(minTime);
  const end = timeToSeconds(maxTime);
  const effectiveEnd = start <= end ? end : 86399;
  const randomSec = randInt(start, effectiveEnd);

  const h = Math.floor(randomSec / 3600);
  const m = Math.floor((randomSec % 3600) / 60);
  const s = randomSec % 60;

  return dayjs(date)
    .hour(h)
    .minute(m)
    .second(s)
    .format("YYYY-MM-DD HH:mm:ss");
};

function generarHoraTipoComida(tipoComida, fecha) {
  let horaMin, horaMax, minutoMax;

  if (tipoComida === 1) {
    // Almuerzo
    horaMin = 10;
    horaMax = 16;
    minutoMax = 40;
  } else if (tipoComida === 2) {
    // Merienda
    horaMin = 17;
    horaMax = 22;
    minutoMax = 59;
  } else {
    return fecha.second(0); 
  }

  const horaActual = fecha.hour();
  const minutoActual = fecha.minute();

  const dentroDelRango =
    (horaActual > horaMin || (horaActual === horaMin && minutoActual >= 0)) &&
    (horaActual < horaMax ||
      (horaActual === horaMax && minutoActual <= minutoMax));

  if (dentroDelRango) {
    // 🔄 CORREGIDO: reasignación con segundos en 0
    return (fecha = fecha.second(0));
  }

  // Generar nueva hora aleatoria dentro del rango
  const horaRandom = randInt(horaMin, horaMax);
  const minutoRandom = randInt(0, horaRandom === horaMax ? minutoMax : 59);

  // 🔄 CORREGIDO: nueva fecha con hora, minuto y segundos 0
  return (fecha = fecha.hour(horaRandom).minute(minutoRandom).second(0));
}

export const buildCodigoReporte = (item) => {
  const tipoComida = parseInt(item.pre_comida_id);
  const codUsuario = item.pre_usuarios.code.toString().padStart(4, "0");

  let fecha = dayjs(item.create_at).tz("America/Guayaquil");

  // ✅ Siempre aplicar el formateo correcto
  fecha = generarHoraTipoComida(tipoComida, fecha);

  console.log("Fecha generada:", fecha.format("YYYY-MM-DD HH:mm:ss"));

  const claveMin = fecha.format("YYYYMMDDHHmm");
  const nextCount = (minuteCounters.get(claveMin) ?? 0) % 100;
  minuteCounters.set(claveMin, nextCount + 1);

  const sufijo = nextCount.toString().padStart(2, "0");

  return `${codUsuario}${claveMin}${sufijo}4008`;
};
